module.exports = __webpack_public_path__ + "static/media/onePlanGroupLogo.8b70a64a.svg";